var n = /* @__PURE__ */ ((t) => (t[t.TRACE = 0] = "TRACE", t[t.DEBUG = 1] = "DEBUG", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT", t))(n || {});
const s = class {
  constructor(t) {
    this.defaultLevel = 3, this.noop = (...r) => {
    }, this.loggerName = t || "";
  }
  setLevel(t) {
    this.level = t;
  }
  getLevel() {
    return typeof this.level == "number" && isFinite(this.level) && Math.floor(this.level) === this.level ? this.level : this.defaultLevel;
  }
  shouldLog(t) {
    switch (this.getLevel()) {
      case 5:
        return !1;
      case 4:
        return t === "error";
      case 3:
        return t === "error" || t === "warn";
      case 2:
        return t === "error" || t === "warn" || t === "info";
      case 1:
        return t === "error" || t === "warn" || t === "info" || t === "log";
      case 0:
      default:
        return !0;
    }
  }
  static getLogger(t, r) {
    if (s.loggers.hasOwnProperty(t))
      return s.loggers[t];
    const e = new r(t);
    return s.loggers[t] = e, e;
  }
};
let g = s;
g.loggers = {};
class o extends g {
  constructor() {
    super(...arguments), this.trace = this.getLoggingMethod("trace"), this.debug = this.getLoggingMethod("debug"), this.info = this.getLoggingMethod("info"), this.warn = this.getLoggingMethod("warn"), this.error = this.getLoggingMethod("error");
  }
  setLevel(r) {
    super.setLevel(r), this.trace = this.getLoggingMethod("trace"), this.debug = this.getLoggingMethod("debug"), this.info = this.getLoggingMethod("info"), this.warn = this.getLoggingMethod("warn"), this.error = this.getLoggingMethod("error");
  }
  static getLogger(r) {
    return super.getLogger(r, o);
  }
  getLoggingMethod(r) {
    const e = r === "debug" ? "log" : r;
    return this.shouldLog(e) ? Function.prototype.bind.call(console[e], console, `${this.loggerName}: `) : this.noop;
  }
  shouldLog(r) {
    return console[r] ? super.shouldLog(r) : !1;
  }
}
class i extends g {
  constructor() {
    super(...arguments), this.trace = this.noop, this.debug = this.noop, this.info = this.noop, this.warn = this.noop, this.error = this.noop;
  }
  static getLogger(r) {
    return super.getLogger(r, i);
  }
}
export {
  o as ConsoleLogger,
  n as LogLevel,
  i as NullLogger
};
